/**
 * @generated SignedSource<<9969fd8c6f636d28d981a8d49d85d690>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskCompletionRecordItem_taskCompletionRecord$data = {
  readonly id: string;
  readonly createdAt: any;
  readonly author: {
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
  };
  readonly task: {
    readonly id: string;
    readonly template: {
      readonly id: string;
      readonly name: string;
    };
  };
  readonly " $fragmentType": "TaskCompletionRecordItem_taskCompletionRecord";
};
export type TaskCompletionRecordItem_taskCompletionRecord = TaskCompletionRecordItem_taskCompletionRecord$data;
export type TaskCompletionRecordItem_taskCompletionRecord$key = {
  readonly " $data"?: TaskCompletionRecordItem_taskCompletionRecord$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskCompletionRecordItem_taskCompletionRecord">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskCompletionRecordItem_taskCompletionRecord",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationUser",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskTemplate",
          "kind": "LinkedField",
          "name": "template",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TaskCompletionRecord",
  "abstractKey": null
};
})();

(node as any).hash = "05ef251a95b50dbf64f37867324ad5f2";

export default node;
